import { render, staticRenderFns } from "./k8tag.vue?vue&type=template&id=2d501f1a&scoped=true&"
import script from "./k8tag.vue?vue&type=script&scoped=true&lang=js&"
export * from "./k8tag.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./k8tag.vue?vue&type=style&index=0&id=2d501f1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d501f1a",
  null
  
)

export default component.exports